import React, { useState, useEffect } from 'react';
import { Menu, X, Server, Cloud, Terminal } from 'lucide-react';
import { Link } from './ui/Link';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-slate-900/95 backdrop-blur-sm shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Terminal className="w-8 h-8 text-teal-500 mr-2" />
            <span className="text-white font-bold text-xl">PStechlab</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link href="#services">Services</Link>
            <Link href="#hire">Hire Us</Link>
            <Link href="#contact">Contact</Link>
            <a 
              href="#contact" 
              className="px-4 py-2 rounded-md bg-teal-500 hover:bg-teal-600 text-white font-medium transition-colors duration-300"
            >
              Get Started
            </a>
          </nav>

          {/* Mobile Navigation Toggle */}
          <button 
            className="md:hidden text-white focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div 
        className={`md:hidden absolute top-full left-0 right-0 bg-slate-900/95 backdrop-blur-sm transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-64 border-b border-slate-700' : 'max-h-0'
        }`}
      >
        <div className="container mx-auto px-4 py-4">
          <nav className="flex flex-col space-y-4">
            <Link href="#services" onClick={() => setIsOpen(false)}>Services</Link>
            <Link href="#hire" onClick={() => setIsOpen(false)}>Hire Us</Link>
            <Link href="#contact" onClick={() => setIsOpen(false)}>Contact</Link>
            <a 
              href="#contact" 
              className="px-4 py-2 rounded-md bg-teal-500 hover:bg-teal-600 text-white font-medium transition-colors duration-300 inline-block text-center"
              onClick={() => setIsOpen(false)}
            >
              Get Started
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;